import React from 'react';
import messages from "res/messages/farsi";
import IconTitleValue from "components/textValue/IconTitleValue";
import getDateString from "components/utils/DateUtility";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import {Divider} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import getColorByOrderStatus from "./OrderUtility";
import StandardButton from "components/buttons/StandardButton";
import {IsM_SM} from "my-styles/media/media";

import ICEnvironmentSupporter from "res/images/environment_supporter.png";
import ICArrowBackIosIcon from "res/images/left_arrow_dark.png";
import ICLocation from "res/images/location_white.png";
import ICEdit from "res/images/edit_white.png";
import ICDelete from "res/images/delete_white.png";
import ICDone from "res/images/done_white.png";
import ICCalender from "res/images/calendar.png";
import ICAddress from "res/images/address.png";
import ICPayment from "res/images/payment.png";
import ICStatus from "res/images/done.png";

export default function Order(props) {

    const history = useHistory()
    let order = props.order
    let itemCount = IsM_SM() ? 3 : 5

    const onShowOrderDetail = (e) => {
        props.onNavigate(history, '/orderDetail', {
            order_id: order.order_id,
            page: props.page,
            orderStatusId: props.orderStatusId
        })
        e.stopPropagation()
    }

    return (<div className="fullWidth marginSmall">
        {order && !order.isTemp &&
        <div className="marginTopBottomSmall card fullHeight" onClick={onShowOrderDetail}>
            <div className="horizontalFullScreen">
                <div className="card_blue_left_curve marginTopBottomMedium">
                    <IconTitleValue
                        valueClassName={"whiteColor"}
                        titleClassName={"whiteColor"}
                        title={messages.orderNumber}
                        value={order.order_id}/>
                </div>
                <div style={{position: "absolute", left: "0"}} className="marginTopBottomMedium">
                    <div className="card_pink_right_curve">
                        <IconTitleValue
                            valueClassName={"whiteColor"}
                            titleClassName={"whiteColor"}
                            title={messages.totalOrderPriceNew}
                            value={order.total}/>
                    </div>
                    {order.is_environment_supporter &&
                    <img src={ICEnvironmentSupporter} alt="" className="mediumIcon toLeft marginSmall"/>
                    }
                </div>
            </div>
            <div className="marginRightSmall">
                <IconTitleValue
                    valueClassName={getColorByOrderStatus(order.order_status_id) + " mediumTextBold"}
                    icon={<img src={ICStatus} alt="" className="xxSmallIcon"/>}
                    title={messages.orderStatus}
                    value={order.is_modified_by_system ? order.order_status + " " + messages.system : order.order_status}/>
                <IconTitleValue
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICCalender} alt="" className="xxSmallIcon"/>}
                    title={messages.deliverDate}
                    value={getDateString(order.date_added) + " " + order.date_added_time}/>
                <IconTitleValue
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICPayment} alt="" className="xxSmallIcon"/>}
                    title={messages.paymentType}
                    value={order.payment_type_txt}/>
                <IconTitleValue
                    maxLength={100}
                    valueClassName={"mediumTextBold"}
                    icon={<img src={ICAddress} alt="" className="xxSmallIcon"/>}
                    title={messages.deliverAddress}
                    value={order.address}/>
            </div>
            {order.product &&
            <div>
                <table className="horizontalFullScreen">
                    <tbody>
                    <tr>
                        {order.product.map((product, index) => {
                            if (index < itemCount) {
                                return (
                                    <td key={index}>
                                        <div className="horizontalScreen">
                                            <img src={product.image} alt="" className="largeIcon"/>
                                            <div>
                                                <Divider orientation={"vertical"}/>
                                            </div>
                                        </div>
                                    </td>
                                )
                            } else {
                                return null
                            }
                        })}
                        {order.product.length > itemCount &&
                        <td>
                            <div className="horizontalScreen grayColor marginRightMedium">
                                {(order.product.length - itemCount).toString() + "+"}
                            </div>
                        </td>
                        }
                        {order.product &&
                        <td>
                            <StandardButton
                                icon={<img src={ICArrowBackIosIcon} alt="" className="xxxxSmallIcon"/>}
                                onClick={onShowOrderDetail}/>
                        </td>
                        }
                    </tr>
                    </tbody>
                </table>
            </div>
            }
            {order.reserve_to.length > 0 &&
            <div style={{padding: 5}}
                 className="marginMedium redColor mediumTextBold center border_gray">
                {order.reserve_to}
            </div>
            }
            <div className="horizontalScreen" style={{float: "left"}}>
                {order.allow_edit && order.allow_edit !== 'false' &&
                <div className="marginSmall">
                    <IconTitleButtonRound
                        height={"2.7em"}
                        direction="ltr"
                        fontSize="smallTextBold"
                        title={messages.editOrder}
                        icon={<img className="xxSmallIcon" src={ICEdit} alt=""/>}
                        onClick={(e) => {
                            props.onEdit(order)
                            e.stopPropagation()
                        }}/>
                </div>
                }
                {order.allow_delete &&
                <div className="marginSmall">
                    <IconTitleButtonRound
                        height={"2.7em"}
                        direction="ltr"
                        fontSize="smallTextBold"
                        title={messages.cancelOrder}
                        icon={<img className="xxSmallIcon" src={ICDelete} alt=""/>}
                        onClick={(e) => {
                            props.onCancel(order)
                            e.stopPropagation()
                        }}/>
                </div>
                }
                {order.allow_on_map &&
                <div className="marginSmall">
                    <IconTitleButtonRound
                        height={"2.7em"}
                        direction="ltr"
                        fontSize="smallTextBold"
                        title={messages.peykLocation}
                        icon={<img className="xxSmallIcon" src={ICLocation} alt=""/>}
                        onClick={(e) => {
                            props.onNavigate(history, '/driverLocation?id=' + order.order_id)
                            e.stopPropagation()
                        }}/>
                </div>
                }
                {order.allow_proccess &&
                <div className="marginSmall">
                    <IconTitleButtonRound
                        height={"2.7em"}
                        direction="ltr"
                        fontSize="smallTextBold"
                        title={messages.completeOrder}
                        icon={<img className="xxSmallIcon" src={ICDone} alt=""/>}
                        onClick={(e) => {
                            props.onCompleteOrder(order)
                            e.stopPropagation()
                        }}/>
                </div>
                }
            </div>
        </div>
        }
    </div>)
}